import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateIdentificationDocumentQueries } from "web_myplann/Api/Client/invalidateIdentificationDocumentQueries";
import { deleteClientIdentificationDocumentsIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useDeleteIdentificationDocumentMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((id: number) =>
			deleteClientIdentificationDocumentsIdV2(id),
		),
		onSuccess: () => {
			invalidateIdentificationDocumentQueries(queryClient);
		},
	});
};
